require('../modules/web.dom-collections.iterator');
require('../modules/es.string.iterator');
var isIterable = require('../internals/is-iterable');

module.exports = isIterable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/is-iterable.js
// module id = 468
// module chunks = 0